import React, { useContext, useState, useEffect } from 'react';
import { DataContext } from '../context/DataContext';
import Footer from "../components/Footer";

/*  Begin By Javi */
import Header from './Header';
import alertify from "alertifyjs";
import { Loader } from "../util/loader";
import { getStorage, getStorageList } from "../util/auth";
import { apiHorario } from "../api";
import HorarioM from './Movil/Horario-m'
import utils from "./../util";
/* End By Javi */

let codigo = 0;
const { isMobile } = utils
export const Horarios = () => {
  /* Begin By Javi */
  const [_isMobile] = useState(isMobile());
  const [Loading, setloading] = useState(true);
  const alertMessage = "Notificación de Horiario";
  let dataStorage = getStorage("studientActive");
  let dataListStorage = getStorageList("studientList");
  /* End By Javi */
  const { data, setData } = useContext(DataContext);
  const [horarios, setHorarios] = useState([]);

  const ActiveHorario = () => {
    codigo =
      data == undefined || data.student == undefined
        ? dataStorage.Codigo
        : data.student.Codigo;
    const promise = apiHorario.listar(codigo, alertMessage);
    promise.then((res) => {
      setloading(false);
      setHorarios(null);
      if (res != undefined) {
        setHorarios(res.dayArray);
      }
    });
  };
  useEffect(
    () => {
      setData({ ...data, students: dataListStorage, student: dataStorage });
      if (dataStorage.Codigo == undefined || data == undefined && dataListStorage.length != 1) {
        setloading(false);
        alertify
          .alert("Debe seleccionar un Estudiante", function () {
            window.location.href = "./home";
          })
          .setHeader(alertMessage);
        return;
      }
      ActiveHorario();
    },
    [setData],
    [setHorarios]
  );

  const devolverHorarioPorDia = (dia) => {
    let children = [];
    if (horarios.length > 0) {
      children.push(
        horarios
          .filter((u) => u.dayName == dia)
          .map((hor, i) => {
            return hor.timeArray.map((time, i) => {
              return (
                <div
                  className=" card background-horario mb-3"
                  style={{ width: "10rem",alignItems:"center",margin:"auto", borderRadius:"0px" }}
                >
                  <div className="card-body">
                    <p className="card-title">{time.courseName}</p>
                    <p
                      className="card-subtitle mb-2 text-muted "
                      style={{ fontSize: "0.8em" }}
                    >
                      AULA : {time.classRoom}
                    </p>
                    <p className="card-subtitle" style={{ fontSize: "0.7em" }}>
                      {" "}
                      {time.timeStart} - {time.timeEnd}
                    </p>
                  </div>
                </div>
              );
            });
          })
      );
    }
    return children;
  };

  const devolverHorarioBody = () => {
    return (
      <>
        {horarios != undefined && horarios.length != 0 ? (
          <tr>
            <td style={{width:"10%" }}>{devolverHorarioPorDia("LUNES")}</td>
            <td style={{width:"10%" }}>{devolverHorarioPorDia("MARTES")}</td>
            <td style={{width:"10%" }}>{devolverHorarioPorDia("MIÉRCOLES")}</td>
            <td style={{width:"10%" }}>{devolverHorarioPorDia("JUEVES")}</td>
            <td style={{width:"10%" }}>{devolverHorarioPorDia("VIERNES")}</td>
            <td style={{width:"10%" }}>{devolverHorarioPorDia("SABADO")}</td>
            <td style={{width:"10%" }}>{devolverHorarioPorDia("DOMINGO")}</td>
          </tr>
        ) : (
          <tr>
            <td colSpan={7} style={{ textAlign: "center"}}>
              No existen Horarios...
            </td>
          </tr>
        )}
      </>
    );
  };

  return (
    <div>
      {Loader(Loading)}
      {_isMobile ? (
        <>
          <div className="contend">
            <div className="text col-12">
              {data != undefined && data.student != undefined ? (
                <Header
                  objData={data}
                  Title={"Horarios"}
                  page={"C"}
                  objActiveAlummno={ActiveHorario}
                  isMobile={_isMobile}
                />
              ) : (
                ""
              )}
              <div>
                <div>
                  <div className="mt-2 contend-horario m-auto">
                    {horarios != undefined &&
                    horarios != null &&
                    horarios.length != 0 ? (
                      horarios
                        .filter((_) => _.dayName != "")
                        .map((_, i) => {
                          return <HorarioM key={i} objHorario={_} />;
                        })
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        No existen Horarios...
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="contend">
            <div className="text col-12">
              <Header
                objData={data}
                Title={"Horarios"}
                objActiveAlummno={ActiveHorario}
              />
              <div className=" mt-4 ">
                <div className="mt-4">
                  <table className="table">
                    <thead className="background-sub-cursos">
                      <tr>
                        <th scope="col-2" className="text-card">
                          Lunes
                        </th>
                        <th scope="col-2" className="text-card">
                          Martes
                        </th>
                        <th scope="col-2" className="text-card">
                          Miércoles
                        </th>
                        <th scope="col-2" className="text-card">
                          Jueves
                        </th>
                        <th scope="col-2" className="text-card">
                          Viernes
                        </th>
                        <th scope="col-2" className="text-card">
                          Sábado
                        </th>
                        <th scope="col-2" className="text-card">
                          Domingo
                        </th>
                      </tr>
                    </thead>
                    <tbody >{devolverHorarioBody()}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};